export default __webpack_public_path__ + "static/media/laza_l.d0b14e8b.jpg";